module.exports = __webpack_public_path__ + "static/Zaira-Moura-60b4722c235673778c6c63c46ae904bd.jpg";